exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".default-topping[data-v-def541b0],.extra-topping[data-v-def541b0]{margin-left:5px;margin-top:8px;cursor:pointer}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/menu/AvailableForm.vue"],"names":[],"mappings":"AACA,kEAEE,gBAAiB,AACjB,eAAgB,AAChB,cAAgB,CACjB","file":"AvailableForm.vue","sourcesContent":["\n.default-topping[data-v-def541b0],\n.extra-topping[data-v-def541b0]{\n  margin-left: 5px;\n  margin-top: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-def541b0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/views/admin/menu/AvailableForm.vue
// module id = 1551
// module chunks = 0